import React from 'react';
import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';

export const SATURATE_MAX = 400;
export const TEMPERATURE_MIN = 1500;
export const TEMPERATURE_MAX = 11500;

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.PICTURE_COLOR_RESET,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.SATURATE,
        label: FormItemLabelName.SATURATE,
        options: {
            suffix: '%',
            min: 0,
            max: SATURATE_MAX,
            barStyle: { background: 'linear-gradient(270deg, #FF0000 2.16%, #FFFFFF 100%)' },
            fillStyle: { background: 'transparent' },
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.SLIDER,
        name: FormItemName.COLOR_TEMPERATURE,
        label: FormItemLabelName.COLOR_TEMPERATURE,
        options: {
            min: TEMPERATURE_MIN,
            max: TEMPERATURE_MAX,
            barStyle: { background: 'linear-gradient(270deg, #FF9900 2.16%, #0066FF 100%)' },
            fillStyle: { background: 'transparent' },
        },
        defaultValue: TEMPERATURE_MIN,
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.PICTURE_RECOLOR_TEXT,
        content: <span style={{ fontSize: 12, color: 'rgba(0, 0, 0)' }}>{FormItemLabelName.PICTURE_RECOLOR}</span>,
        style: {
            minWidth: 72,
            display: 'flex',
            alignItems: 'center',
        },
    },
    {
        type: FormItemType.CUSTOM,
        name: FormItemName.PICTURE_RECOLOR,
        content: '',
        style: {
            minWidth: 72,
            display: 'flex',
            justifyContent: 'end',
        },
    },
];
